import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrEnhancedSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_enhanced_select"}/>
}
